import { request } from 'utils/requests'
import { cachedFetch, cacheClear } from 'utils/memoryCache'
import { CACHE_TTL } from 'utils/cacheTtl'

const PREFIX = 'settings:actionTypes:'

/**
 * Lista todos os tipos de ação
 */
export const listActionTypes = async (params = {}) => {
  try {
    return await cachedFetch(
      `${PREFIX}list:${JSON.stringify(params)}`,
      async () => request.get('/action-types', { params }),
      { ttlMs: CACHE_TTL.SETTINGS_STABLE }
    )
  } catch (error) {
    console.error('Erro ao listar tipos de ação:', error)
    throw error
  }
}

/**
 * Busca um tipo de ação por ID
 */
export const getActionType = async (id) => {
  try {
    return await cachedFetch(
      `${PREFIX}one:${id}`,
      async () => request.get(`/action-types/${id}`),
      { ttlMs: CACHE_TTL.SETTINGS_STABLE }
    )
  } catch (error) {
    console.error('Erro ao buscar tipo de ação:', error)
    throw error
  }
}

/**
 * Cria um novo tipo de ação
 */
export const createActionType = async (data) => {
  try {
    const response = await request.post('/action-types', data)
    cacheClear(PREFIX)
    return response
  } catch (error) {
    console.error('Erro ao criar tipo de ação:', error)
    throw error
  }
}

/**
 * Atualiza um tipo de ação
 */
export const updateActionType = async (id, data) => {
  try {
    const response = await request.put(`/action-types/${id}`, data)
    cacheClear(PREFIX)
    return response
  } catch (error) {
    console.error('Erro ao atualizar tipo de ação:', error)
    throw error
  }
}

/**
 * Exclui um tipo de ação
 */
export const deleteActionType = async (id) => {
  try {
    const response = await request.delete(`/action-types/${id}`)
    cacheClear(PREFIX)
    return response
  } catch (error) {
    console.error('Erro ao excluir tipo de ação:', error)
    throw error
  }
}

/**
 * Lista tipos de ação ativos
 */
export const listActiveActionTypes = async () => {
  try {
    return await cachedFetch(
      `${PREFIX}active:true`,
      async () => request.get('/action-types', { params: { active: true } }),
      { ttlMs: CACHE_TTL.SETTINGS_STABLE }
    )
  } catch (error) {
    console.error('Erro ao listar tipos de ação ativos:', error)
    throw error
  }
}

/**
 * Lista tipos de ação por categoria
 */
export const listActionTypesByCategory = async (category) => {
  try {
    return await cachedFetch(
      `${PREFIX}category:${category}`,
      async () => request.get('/action-types', { params: { category } }),
      { ttlMs: CACHE_TTL.SETTINGS_STABLE }
    )
  } catch (error) {
    console.error('Erro ao listar tipos de ação por categoria:', error)
    throw error
  }
}

/**
 * Busca tipos de ação por termo
 */
export const searchActionTypes = async (searchTerm) => {
  try {
    return await cachedFetch(
      `${PREFIX}search:${searchTerm}`,
      async () => request.get('/action-types', { params: { search: searchTerm } }),
      { ttlMs: CACHE_TTL.SEARCH }
    )
  } catch (error) {
    console.error('Erro ao buscar tipos de ação:', error)
    throw error
  }
}
